import { isShowWeCouponWxSubscribe, setLastSubTime } from './wx-subscribe';
import { showToast } from '@tencent/wphk-components-toast';
import { i18n } from '@/i18n';

export type NotifyActionRet = {
  name: string;
  data?: {
    err?: any,
    result?: any
  };
};
/** 领券成功后订阅弹窗是否打开枚举 */
export enum HandleSubScribeRes {
  /** 展示订阅弹窗 */
  showSubscribeDialog = 'show',
  /** 隐藏订阅弹窗 */
  hideSubscribeDialog = 'hide',
  /** 领券失败 */
  getCouponErr = 'err'
}
/**
 * 处理领券后展示订阅弹窗还是 toast 提示
 * @param notifyActionRet
 * @param showDialog
 */
export async function handleGetCouponAction(
  notifyActionRet: NotifyActionRet,
  setUnSubscribeTmpIds: Function,
): Promise<HandleSubScribeRes> {
  const { name, data } = notifyActionRet;
  // 是领券后的回调
  if (name === 'getCoupon' && !data?.err) {
    // 拉取是否展示订阅弹窗
    const res = await isShowWeCouponWxSubscribe();
    // 可以显示订阅弹窗
    if (res.isShow) {
      // 弹出订阅弹窗后设置弹出时间到本地存储
      setLastSubTime();
      // 设置订阅模板 id和提示内容
      setUnSubscribeTmpIds(res.unSubscribeTmpIds, res.subscribeTipContent);
      return HandleSubScribeRes.showSubscribeDialog;
    }
    // toast 提示领取成功
    showToast({
      title: i18n('領取成功'),
      duration: 1000,
    });
    return HandleSubScribeRes.hideSubscribeDialog;
  }
  return HandleSubScribeRes.getCouponErr;
}
